import { useState } from "react";
import "../css/PopUpJetonAcces.css";

import { useAuth } from "../AuthContext";

export default function PopupJetonAcces({ afficherPopupAdmin, setAfficherPopupAdmin }) {
  const { setIsAdmin } = useAuth();
  const [token, setToken] = useState("");
  const [error, setError] = useState(null);
  const [showWelcomePopup, setShowWelcomePopup] = useState(false);

  const validerJetonModeAdmin = async () => {
    if (!token) {
      return;
    }
    try {
      const response = await fetch("https://carto.api.toobib.org/api/verifier_jeton_admin", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ token }),
      });
      const data = await response.json();

      if (response.ok) {
        setAfficherPopupAdmin(false);
        setIsAdmin(true);
        setShowWelcomePopup(true); 
      } else {
        setError("Jeton invalide. Veuillez réessayer.");
      }
    } catch (error) {
      setError("Erreur de connexion au serveur.");
    }
  };

  if (!afficherPopupAdmin && !showWelcomePopup) return null;

  return (
    <>
      {afficherPopupAdmin && (
        <div className="jetonacces-overlay">
          <div className="jetonacces-container">
            <h2 className="jetonacces-title">Accéder à l'espace administrateur</h2>
            <input
              type="password"
              placeholder="Entrez votre jeton d'accès"
              value={token}
              onChange={(e) => setToken(e.target.value)}
              className="jetonacces-input"
            />
            {error && <p className="jetonacces-error">{error}</p>}
            <div className="jetonacces-boutons">
              <button onClick={() => setAfficherPopupAdmin(false)} className="jetonacces-bouton cancel">Annuler</button>
              <button onClick={validerJetonModeAdmin} className="jetonacces-bouton submit">Valider</button>
            </div>
          </div>
        </div>
      )}

      {showWelcomePopup && (
        <div className="welcome-overlay">
          <div className="welcome-container">
            <h2 className="welcome-title">Bienvenue dans le mode administrateur</h2>
            <p style={{fontFamily:'Interfont', color:"#190b34", fontStyle:'italic'}}>Vous avez désormais accès à des paramètres et options supplémentaires. Merci de ne jamais communiquer votre jeton d'accès aux autres utilisateurs.</p>
            <button onClick={() => setShowWelcomePopup(false)} className="welcome-bouton">Fermer</button>
          </div>
        </div>
      )}
    </>
  );
}